export default {
    title_list: 'Partner Promo Codes',
    title_page: 'Partner Promo Code',
    title_create_page: 'Create partner promo code',
    title_edit_page: 'Change partner promo code',

    filter: {
        labels: {
            code: 'Code',
            partner: 'Partner',
            type: 'Type',
            promo_owner_id: 'Promo owner ID',
            promo_owner: 'Promo owner',
            company_id: 'Company',
        }
    },

    table: {
        labels: {
            id: 'ID',
            code: 'Code',
            partner: 'Partner',
            promo_owner_id: 'Promo owner ID',
            promo_owner: 'Promo owner',
            plan: 'Membership',
            user: 'User',
            type: 'Type',
            activated: 'Is activated',
            created_at: 'Created',
            company_id: 'Company',
        }
    },

    buttons: {
        generate: 'Generate code',
    },

    form: {
        code: 'Code',
        partner: 'Partner',
        plan_id: 'Membership',
        user_id: 'User',
        type: 'Type',
        activated: 'Is activated',
        activated_at: 'Activated date',
        promo_owner_id: 'Promo Owner',
        company_id: 'Company',
    },
}
